export default "__VITE_ASSET__CmlSFRId__"